// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"style_sectionWrapper__ONPZV","gradientOverlay":"style_gradientOverlay__cWadG","innerGradient":"style_innerGradient___mV6_"};